import React from 'react';
import { MessageInfo } from '@/api/types';
import MediaPreview from './MediaPreview';

interface VideoMessageProps {
  message: MessageInfo;
  isOwnMessage: boolean;
}

/**
 * 视频消息组件
 */
const VideoMessage: React.FC<VideoMessageProps> = ({ message, isOwnMessage }) => {
  const attachment = message.decryptedContentData?.attachment;
  
  if (!attachment?.fileId) {
    return (
      <div className={`px-4 py-2 rounded-2xl ${
        isOwnMessage 
          ? 'bg-red-500 text-white rounded-br-md' 
          : 'bg-red-100 text-red-900 rounded-bl-md'
      }`}>
        <p className="text-sm">视频加载失败</p>
      </div>
    );
  }

  // 格式化时长
  const formatDuration = (seconds?: number) => {
    if (!seconds) return '';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // 格式化分辨率
  const formatResolution = (width?: number | null, height?: number | null) => {
    if (!width || !height) return '';
    return `${width}×${height}`;
  };

  return (
    <div className={`rounded-2xl overflow-hidden ${
      isOwnMessage ? 'rounded-br-md' : 'rounded-bl-md'
    }`}>
      <MediaPreview
        fileId={attachment.fileId}
        fileName={attachment.fileName}
        fileSize={attachment.fileSize}
        mediaType="video"
        className="max-w-xs md:max-w-md"
      />
      
      {/* 视频信息 */}
      <div className={`px-3 py-2 text-xs ${
        isOwnMessage 
          ? 'bg-blue-500 bg-opacity-80 text-blue-100' 
          : 'bg-gray-100 text-gray-500'
      }`}>
        <div className="flex items-center justify-between">
          <span className="truncate flex-1">
            {attachment.fileName || '视频文件'}
          </span>
          <div className="flex items-center space-x-2 text-xs">
            {attachment.duration && (
              <span>{formatDuration(attachment.duration)}</span>
            )}
            {(attachment.width && attachment.height) && (
              <span>{formatResolution(attachment.width, attachment.height)}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoMessage;
